import { useCallback, useLayoutEffect, useState } from 'react';

export default function useSideMenuAnimation(isOpen: boolean) {
  const [isRendered, setIsRendered] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isOpenAnimated, setIsOpenAnimated] = useState(false);

  useLayoutEffect(() => {
    if (isOpen) {
      setIsRendered(true);
      setIsClosing(false);
      setIsOpenAnimated(false);

      const frame = requestAnimationFrame(() => {
        setIsOpenAnimated(true);
      });

      return () => cancelAnimationFrame(frame);
    }

    if (!isRendered) return;

    setIsClosing(true);
    setIsOpenAnimated(false);
  }, [isOpen, isRendered]);

  const handleAnimationEnd = useCallback(
    (event: React.AnimationEvent) => {
      if (event.target !== event.currentTarget || !isClosing) return;

      setIsRendered(false);
      setIsClosing(false);
    },
    [isClosing],
  );

  const animationClassName = [isOpenAnimated && !isClosing ? 'is-open' : '', isClosing ? 'is-closing' : '']
    .filter(Boolean)
    .join(' ');

  return {
    isRendered,
    animationClassName,
    handleAnimationEnd,
  };
}
